<template>
    <div id="main-mertric-view">
        <div class="row">
            <div class="col metric-data-table-header">
                <div>
                    <span style="margin-left: 12px; font-weight: bold; font-size: 20px;">{{currentYear}} <div class="inline-separator"></div> {{currentProgram}}</span>
                        <b @click="handleSelectionEdit()" class="edit-link"> <font-awesome-icon icon="pencil-alt" style="color: #666666; font-size: 18px;" /> <span style="padding-left: 6px;">Modify</span></b>
                        <b @click="renderHelpSection()" class="edit-link">
                            <font-awesome-icon icon="question-circle" style="color: #666666; font-size: 18px;" />
                            <span style="padding-left: 6px;">Help</span></b>
                        <div v-if="renderSelection">
                            <!-- @paramsChange="$emit('paramsChange')" -->
                            <ProgramSelection @paramsChange="onParamsChange" :yearSelection="currentYear" @closeWidget="unMountSelection" :hasChanges="changes.unsavedChanges.length > 0 || changes.unsavedComments.length > 0" :mode="'widget'" ></ProgramSelection>
                        </div>
                        <div v-if="showHelpMenu">
                            <div id="myModal" class="modalMetric">
                            <!-- Modal content -->
                            <div class="modal-content-metric">
                                <div style="display: flex; justify-content: space-between; font-weight: bold; font-size: 17px;">
                                    <div>Help</div>
                                    <div style="margin-right: 16px; cursor: pointer;" @click="closeHelpMenu">
                                       <font-awesome-icon icon="times" style="color: #666666; font-size: 17px;" />
                                    </div>
                                </div>
                                <hr style="margin-top: 5px; margin-bottom: 5px;" />
                                <div class="help-item">
                                    <div class="help-item-head" style="display: flex; justify-content: flex-end; border: 1px solid #cccccc;"> 00 </div>
                                    <div class="help-item-body"> 
                                        <span style="font-weight: bold;"> Draft </span>
                                        <span style="font-size: 80%;"> Only you can view. Changes will be <br/> lost if not saved. </span>
                                    </div>
                                </div>
                                <div class="help-item">
                                    <div class="help-item-head" style="display: flex; justify-content: flex-end; background-color: rgb(157, 242, 170);"> 00 </div>
                                    <div class="help-item-body"> 
                                        <span style="font-weight: bold;"> Saved </span>
                                        <span style="font-size: 80%;"> Value can be updated and will not <br/> appear in any reporting until posted. </span>
                                    </div>
                                </div>
                                <div class="help-item">
                                    <div class="help-item-head" style="display: flex; justify-content: flex-end; background-color: #ececec;    border: 1px solid #cccccc;"> 00 </div>
                                    <div class="help-item-body"> 
                                        <span style="font-weight: bold;"> Posted </span>
                                        <span style="font-size: 80%;"> Value will appear in reporting.<br/> Only Admin can edit. </span>
                                    </div>
                                </div>
                                <hr style="margin-top: 5px; margin-bottom: 0px;" />
                                <div class="help-item">
                                    <div class="help-item-head" style="display: flex;border: 0;justify-content: flex-end; background-color: #bfbfbf; color: red;"> 00 </div>
                                    <div class="help-item-body"> 
                                        <span style="font-size: 80%;"> Red font indicates missed target. </span>
                                    </div>
                                </div>
                                <div class="help-item">
                                    <div class="help-item-head" style="display: flex; height: 30px; justify-content: flex-end; border: 1px solid #cccccc; background-color: yellow;"></div>
                                    <div  class="help-item-body"> 
                                        <span style="font-size: 80%;"> Posted value was un-posted, ready<br/> for update. </span>
                                    </div>
                                </div>
                                <div class="help-item">
                                    <div class="help-item-head" style="display: flex; justify-content: flex-end; border: 1px solid #cccccc;">
                                        <div class="red-banner"> </div>
                                        00
                                    </div>
                                    <div class="help-item-body"> 
                                        <span style="font-size: 80%;"> Comment is added. Click and select <br /> comment to read or post new comment. </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                </div>
                <div v-if="changes.unsavedChanges.length > 0 || changes.unsavedComments.length > 0" style="display: flex; justify-content: center; align-items: center;">
                    <div v-if="changes.unsavedChanges.length > 0 || changes.unsavedComments.length > 0" class="unsaved-comments">
                        <span v-if="changes.unsavedChanges.length > 0"> <b>{{changes.unsavedChanges.length }}</b> change(s) made </span>&nbsp;
                        <span v-if=" false && changes.unsavedComments.length > 0"> <b>{{changes.unsavedComments.length }}</b> unsaved comment(s)</span>
                    </div>
                     <div v-if="String(currentUserGroups).toLowerCase().indexOf('admin') > -1 || String(currentUserGroups).toLowerCase().indexOf('poweruser') > -1" >
                        <!-- Save Changes Button -->
                        <button class="btn btn-warning-arp" style="height: 33px; padding: 8px 20px 12px 20px;" @click="saveModalShow = !saveModalShow" >
                            Save Now
                        </button>
                    </div>
                    <div v-if="String(currentUserGroups).toLowerCase().indexOf('admin') > -1 || String(currentUserGroups).toLowerCase().indexOf('poweruser') > -1" >
                        <!-- Clear All button -->
                        <div @click="handleDiscard" class="back-link">
                            DISCARD CHANGES
                        </div>
                    </div>
                </div>
                <div class="action-container">
                    <div v-if="(String(currentUserGroups).toLowerCase().indexOf('admin') > -1)" >
                         <button @click="handleClearMetricClick" class="btn btn-action-arp" style="height:34px; width: 150px;">
                            Clear Metrics
                        </button>
                    </div>
                    <div v-if="(String(currentUserGroups).toLowerCase().indexOf('admin') > -1 || String(currentUserGroups).toLowerCase().indexOf('poweruser') > -1)">
                         <button class="btn btn-warning-arp" style="height: 33px; padding: 8px 20px;margin: 0px 12px;" @click="postModalShow = !postModalShow">
                            Post
                        </button>
                    </div>
                    <div class="separator-vertical"></div>
                    <div @click="toggleFullScreen" style="width: 40px; padding-left: 4px;">
                        <font-awesome-icon v-if="!expandMode" icon="expand-alt" style="color: #666666; font-size: 24px;" />
                        <font-awesome-icon v-if="expandMode" icon="compress-alt" style="color: #666666; font-size: 24px;" />
                    </div>
                </div>
            </div>
        </div>
        <div id="row hot-preview">
            <HotTable :id="root" :settings="hotSettings" ref="hotTableComponent" :style="{ minHeight: tableHeight, overflowX: 'hidden'}" @onMetricCommentBtnClk="metricCommentsFunc"></HotTable>
        </div>
        <div class="row">
            <!-- Comment Modal 
            <b-modal v-model="commentsModalShow" title="Comments" ref="commentsModal" @ok="handleOk">
                Looks like you are trying to update the following content <br>
                Metric name: {{changes.currentChanges.name}} <br>
                Month: {{changes.currentChanges.column }} <br>
                From: {{changes.currentChanges.beforeValue}} <br>
                To: {{changes.currentChanges.afterValue}} <br>
                <form @submit.stop.prevent="handleSubmit">
                    <b-form-input type="text" placeholder="Please enter the comments here" v-model="changes.currentChanges.comments.comment" ></b-form-input>
                </form>
            </b-modal>-->

            <!-- Add Comments Modal addCommentsModalShow-->
            <div v-if="false && addCommentsModalShow"  class="clear-metric-modal" title="Ex Metric Level Comments" ref="addCommentsModal" @ok="handleCommentsOk" ok-title="Add Comment" cancel-title="Close" cancel-variant="danger">
                <div v-if="currentCell.canComment">
                    <h5>Adding metric level comment for the following metric</h5> <br>
                    <b>Metric name</b>: {{currentCell.metric_name}} <br>
                    <b>Month</b>: {{currentCell.col }} <br>
                    <b>Current Value</b>: {{currentCell.value}} <br>
                    <!-- isposted: {{changes.currentChanges.isPosted}} -->
                    <form @submit.stop.prevent="handleSubmit">
                        <b-form-input type="text" placeholder="Please enter the comments here" v-model="changes.currentComments.comment" ></b-form-input>
                    </form>
                </div>
                <div v-else>
                    <p>Please click on a cell with data and then click on add comments button to add metric level comments</p>
                </div>
            </div>

            <!-- Save Metrics display Modal -->
            <div class="clear-metric-modal" v-if="saveModalShow" ref="saveModal" ok-title="Save Selected Changes" cancel-title="close" @change="addToSave" @ok="saveChanges">
                 <div style="width: 100%">
                    <div style="display: flex; justify-content: space-between; font-weight: bold; font-size: 20px;"><div>Save changes</div>
                        <div style="margin-right: 16px; cursor: pointer;" @click="saveModalShow = !saveModalShow">
                            <svg class="clear-metric-close" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                            </svg>
                    </div></div>
                    <div class="clear-metric-sub-heading">NOTE: Once the changes are saved, it will be visible to all authorised users. It can be edited too.</div>
                </div>
                <div style="width: 100%; overflow: auto; max-height: 73vh;" v-if="changes.unsavedChanges[0] || changes.unsavedComments[0]">
                    <div style="margin: 10px 0;">
                        <hr />
                    </div>
                    <div style="display: flex; align-items: center; margin-bottom: 20px;">
                        <div style="display: flex; width: 38%;">
                            <input style="margin: 2px 6px 0px 4px;" @click="saveSelectHandler" :checked="selectInputSaveModal" type="checkbox" /> <span style="cursor: pointer; font-size: 95%; font-weight: bold; color: #808080;" @click="saveSelectHandler">Select all</span>
                        </div>
                        <div>
                            <button @click="saveModalShow = !saveModalShow" class="btn btn-action-arp" style="height:34px; width: 75px;">
                                CANCEL
                            </button>
                        </div>
                        <div>
                            <button class="btn btn-warning-arp" style="height: 33px; padding: 8px 20px;" @click="saveChanges">
                                SAVE SELECTED
                            </button>
                        </div>
                    </div>
                    <div v-if="changes.unsavedChanges[0]">
                        <div class="unsaved-changes-main-view">
                            <!--<thead class="thead-dark">
                                <tr>
                                
                                <th scope="col">#</th>
                                <th scope="col">Metric</th>
                                <th scope="col">Month</th>
                                <th scope="col">Old Value</th>
                                <th scope="col">New Value</th>
                                <th scope="col">Comments</th>
                                <th scope="col">Select</th> 
                                </tr>
                            </thead>-->
                            <div v-for="(item, index) in changes.unsavedChanges" :key="index">
                                <!--<th scope="row">{{index}}</th>-->
                                <div style="padding: 4px 0;">
                                    <div class="modal-inner-block">
                                        <div style="margin-right: 20px;margin-top: 8px;">
                                                <input style="margin-left: 8px;" type="checkbox"  :id="item" :value="item" v-model="savedItems.toBeSaved.unsavedChanges"><label for="index"></label>
                                        </div>
                                        <div style="width: 90%; display: flex; flex-direction: column; align-items: flex-start; justify-content: space-between; font-weight: 400;">
                                            <div>{{ item.name }}</div>
                                            <div style="display: flex; color: #A4ADB3; align-items: center; justify-content: space-between; width: 83%; margin: 10px 0; font-size: 80%;">
                                                <div class="modal-month-chip" :style="{backgroundColor: getIndexdColor(index)}">{{ item.column.substring(0,3).toUpperCase() }}</div>
                                                <div class="modal-separator-vertical"></div>
                                                <div>
                                                    <div>New Value</div>
                                                    <div class="modal-value-min-height"  style="color: #000000; font-weight: bold;">{{ item.afterValue }}</div>
                                                </div>
                                                <div class="modal-separator-vertical"></div>
                                                <div>
                                                    <div>Old Value</div>
                                                    <div class="modal-value-min-height" >{{ item.beforeValue }}</div>
                                                </div>
                                            </div>
                                            <div v-if="item.comments.comment" style="word-break: break-word; padding-right: 6px; font-size: 80%; color: #666666;"><span style="border: 0; border-top: 6px solid red; border-left: 12px solid transparent; margin-right: 12px; margin-left: 5px;"></span>{{ item.comments.comment}}</div>
                                            <div v-else><span style="border: 0; border-top: 6px solid #a4adb3; border-left: 12px solid transparent; margin-right: 12px; margin-left: 5px;"></span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="changes.unsavedComments[0]">
                        <div>
                            <div v-for="(item, index) in changes.unsavedComments" :key="index">
                                <div style="padding: 4px 0;">
                                    <div class="modal-inner-block">
                                        <div style="margin-right: 20px;">
                                                <input style="margin-left: 8px;" type="checkbox"  :id="item" :value="item" v-model="savedItems.toBeSaved.unsavedComments"><label for="index"></label>
                                        </div>
                                        <div style="width: 90%; display: flex; flex-direction: column; align-items: flex-start; justify-content: space-between; font-weight: 400;">
                                            <div>{{ item.metric_name }}</div>
                                            <div style="display: flex; color: #A4ADB3; align-items: center; justify-content: space-between; width: 83%; margin: 10px 0; font-size: 80%;">
                                                <div class="modal-month-chip" :style="{backgroundColor: getIndexdColor(index)}">{{ item.month.substring(0,3).toUpperCase() }}</div>
                                                <div>
                                                    <div style="color: #000000; font-weight: bold;">Value</div>
                                                    <div>{{ item.value }}</div>
                                                </div>
                                            </div>
                                            <div v-if="item.comment" style="word-break: break-word; padding-right: 6px; font-size: 80%; color: #666666;"><span style="border: 0; border-top: 6px solid red; border-left: 12px solid transparent; margin-right: 12px; margin-left: 5px;"></span>{{item.comment}}</div>
                                            <div v-else><span style="border: 0; border-top: 6px solid #a4adb3; border-left: 12px solid transparent; margin-right: 12px; margin-left: 5px;"></span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <h4 class="align center">Nothing to save</h4>
                </div>
                <div v-if="false" slot="modal-footer" class="w-100">
                    <p>NOTE: When you click on save changes the unselected items will be discarded</p> 
                    
                    
                    <b-btn class="float-right" variant="dark-green"  @click="saveChanges">Save Selected Items</b-btn>
                    <b-btn class="float-right" variant="secondary"  @click="deSelectAll('save')">Deselect All</b-btn>
                    <b-btn class="float-right" variant="indigo"  @click="selectAll('save')">Select All</b-btn>
                    <b-btn class="float-right" variant="danger"  @click="saveModalShow = !saveModalShow">Close</b-btn>
                </div>
            </div>
            <!-- Post metrics display modal -->
            <div v-if="postModalShow" class="clear-metric-modal">
                <div style="width: 100%">
                    <div style="display: flex; justify-content: space-between; font-weight: bold; font-size: 20px;"><div>Post changes</div>
                        <div style="margin-right: 16px; cursor: pointer;" @click="postModalShow = !postModalShow">
                            <svg class="clear-metric-close" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                            </svg>
                    </div></div>
                    <div class="clear-metric-sub-heading">NOTE: Once the changes are posted, it can't be edited by anyone (except by admin).</div>
                </div>
                <div style="width: 100%" v-if="changes.unsavedChanges[0] || savedItems.list[0]">
                    <div class="" style="overflow: auto; max-height: 73vh;">
                        <div style="margin: 10px 0;">
                        <hr />
                    </div>
                    <div style="display: flex; align-items: center; margin-bottom: 20px;">
                        <div style="display: flex; width: 38%;">
                            <input style="margin: 2px 6px 0px 4px;" @click="postSelectHandler" :checked="selectInputPostModal" type="checkbox" /> <span style="cursor: pointer; font-size: 95%; font-weight: bold; color: #808080;" @click="postSelectHandler">Select all</span>
                        </div>
                        <div>
                            <button @click="postModalShow = !postModalShow" class="btn btn-action-arp" style="height:34px; width: 75px;">
                                CANCEL
                            </button>
                        </div>
                        <div>
                            <button class="btn btn-warning-arp" style="height: 33px; padding: 8px 20px;" @click="postChanges">
                                POST SELECTED
                            </button>
                        </div>
                    </div>
                        <div v-for="(item, index) in changes.unsavedChanges" :key="index">
                            <!--<th scope="row">{{index}}</th>-->
                            <div style="padding: 4px 0;">
                                <div class="modal-inner-block">
                                    <div style="margin-right: 20px;">
                                            <input style="margin-left: 8px;" type="checkbox"  :id="item" :value="item" v-model="postedItems.toBePosted.unsavedChanges"><label for="index"></label>
                                    </div>
                                    <div style="width: 90%; display: flex; flex-direction: column; align-items: flex-start; justify-content: space-between; font-weight: 400;">
                                        <div>{{ item.name }}</div>
                                        <div style="display: flex; color: #A4ADB3; align-items: center; justify-content: space-between; width: 83%; margin: 10px 0; font-size: 80%;">
                                            <div class="modal-month-chip" :style="{backgroundColor: getIndexdColor(index)}">{{ item.column.substring(0,3).toUpperCase() }}</div>
                                            <div class="modal-separator-vertical"></div>
                                            <div>
                                                <div>New Value</div>
                                                <div class="modal-value-min-height" style="color: #000000; font-weight: bold;">{{ item.afterValue }}</div>
                                            </div>
                                            <div class="modal-separator-vertical"></div>
                                            <div>
                                                <div>Old Value</div>
                                                <div class="modal-value-min-height" >{{ item.beforeValue }}</div>
                                            </div>
                                        </div>
                                        <div v-if="item.comments.comment" style="word-break: break-word; padding-right: 6px; font-size: 80%; color: #666666;">
                                            <span style="border: 0; border-top: 6px solid red; border-left: 12px solid transparent; margin-right: 12px; margin-left: 5px;"></span>{{ item.comments.comment}}</div>
                                        <div v-else><span style="border: 0; border-top: 6px solid #a4adb3; border-left: 12px solid transparent; margin-right: 12px; margin-left: 5px;"></span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div v-for="(item, index) in savedItems.list" :key="index">
                            <div style="padding: 4px 0;">
                                <div class="modal-inner-block">
                                    <div style="margin-right: 20px;margin-top: 8px;">
                                            <input style="margin-left: 8px;" type="checkbox"  :id="item" :value="item" v-model="postedItems.toBePosted.savedItems"><label for="index"></label>
                                    </div>
                                    <div style="width: 90%; display: flex; flex-direction: column; align-items: flex-start; justify-content: space-between; font-weight: 400;">
                                        <div>{{ item.metric_name }}</div>
                                        <div style="display: flex; color: #A4ADB3; align-items: center; justify-content: space-between; width: 83%; margin: 10px 0; font-size: 80%;">
                                            <div class="modal-month-chip" :style="{backgroundColor: getIndexdColor(index)}">{{ item.month.substring(0,3).toUpperCase() }}</div>
                                            <div>
                                                <div style="color: #000000; font-weight: bold;">Value</div>
                                                <div>{{ item.value }}</div>
                                            </div>
                                        </div>
                                        <div v-if="item.comment" style="word-break: break-word; padding-right: 6px; font-size: 80%; color: #666666;"><span style="border: 0; border-top: 6px solid red; border-left: 12px solid transparent; margin-right: 12px; margin-left: 5px;"></span>{{item.comment}}</div>
                                        <div v-else><span style="border: 0; border-top: 6px solid #a4adb3; border-left: 12px solid transparent; margin-right: 12px; margin-left: 5px;"></span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="false" slot="modal-footer" class="w-100">
                    <p>NOTE: When you click on post all the unselected items in the unsaved changes will be discarded</p> 
                    
                    
                    <b-btn class="float-right" variant="blue-grey"  @click="postChanges">Post Selected Items</b-btn>
                    <b-btn class="float-right" variant="secondary"  @click="deSelectAll('post')">Deselect All</b-btn>
                    <b-btn class="float-right" variant="indigo"  @click="selectAll('post')">Select All</b-btn>
                    <b-btn class="float-right" variant="danger"  @click="postModalShow = !postModalShow">Close</b-btn>
                </div>
            </div>
            <!-- addCommentsModalShow -->
            <div class="modal" @click="handleModalClick" v-if="addCommentsModalShow">
                <div class="clear-metric-modal" ref="metricCommentsModal" >
                    <div style="width: 100%">
                        <div style="display: flex; justify-content: space-between; font-weight: bold; font-size: 20px;"><div>{{currentCell.metric_name}}</div>
                            <div style="margin-right: 16px; cursor: pointer;" @click="addCommentsModalShow = false">
                                <font-awesome-icon icon="times" style="color: #666666; font-size: 24px;" />
                        </div></div>
                        <div v-if="(String(currentUserGroups).toLowerCase().indexOf('admin') > -1 || String(currentUserGroups).toLowerCase().indexOf('poweruser') > -1)" style="width: 98%; padding-top: 10px; display: flex;justify-content: space-between;">
                            <div style="display: flex;visibility: hidden;">
                                <div style="margin-left: 5px; margin-top: 4px; margin-right: 8px;"><input type="checkbox" :checked="allCommentsSelected" @click="SelectAllComments" /></div><div @click="SelectAllComments">Select All</div>
                            </div>
                            <div @click="deleteComments" style="color: rgb(43, 119, 155); cursor: pointer; padding: 3px 10px; font-size: 15px; font-weight: bold; margin-left: 20px;">
                                DELETE SELECTED
                            </div>
                        </div>
                    </div>
                    <div style="padding: 10px; width: 100%;">
                        <div style="width: 100%;" v-for="(commentsPerMonth, index) in metricCommentsForModal" :key="index">
                            <div style="width: 100%" v-if="showCommForSpecificMonth(index)">
                                <div style="background-color: tomato; width: 45px; font-size: 80%; text-align: center;font-weight: bold; color: rgb(255, 255, 255); padding: 2px 8px; border-radius: 15px;">{{longMonths[index].substr(0,3).toUpperCase()}}</div>
                                <div style="width: 100%" v-for="(item, i) in commentsPerMonth" :key="i">
                                    <div style="width: 100%; padding: 10px; padding-left: 26px;" v-for="el in item" :key="el.timeStamp">
                                        <div style="display: flex; justify-content: flex-start;">
                                            <div @click="selectComment(el, index, currentCell.metric_name)" style="margin-top: 5px;margin-right: 20px;">
                                                <input type="checkbox" :checked="isCommentSelected(el, index)"/>
                                            </div>
                                            <div>
                                                <div style="color: #707070">{{ el.userEmail }}</div>
                                                <div>{{ el.comment }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top: 10px; margin-bottom: 10px; width: 95%">
                            <hr />
                        </div>
                        <div v-if="(String(currentUserGroups).toLowerCase().indexOf('admin') > -1 || String(currentUserGroups).toLowerCase().indexOf('poweruser') > -1)" style="width: 100%">
                            <div style="padding: 12px; display: flex; justify-content: space-between; width: 98%; border: 1px solid #dcdcdc; border-radius: 8px; margin-top: 10px; height: 46px; padding-top:0; padding-left: 0;">
                                <div><input v-model="changes.currentComments.comment" style="height: 42px; border: 0; width: 340px; padding-left: 12px;" type="text" placeholder="Add Comment" /></div>
                                <div @click="addComments" style="cursor:pointer; position: relative; right: 0px; top: 10px;">
                                    <font-awesome-icon icon="paper-plane" style="color: #2b779b; font-size: 18px;" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Metric Comments Display Modal -->
            <div class="modal" @click="handleModalClick" v-if="metricCommentsModalShow">
                <div class="clear-metric-modal" ref="metricCommentsModal" >
                    <div style="width: 100%">
                        <div style="display: flex; justify-content: space-between; font-weight: bold; font-size: 20px;"><div>{{currentCell.metric_name}}</div>
                            <div style="margin-right: 16px; cursor: pointer;" @click="metricCommentsModalShow = false">
                                <font-awesome-icon icon="times" style="color: #666666; font-size: 24px;" />
                        </div></div>
                        <div v-if="(String(currentUserGroups).toLowerCase().indexOf('admin') > -1 || String(currentUserGroups).toLowerCase().indexOf('poweruser') > -1)" style="width: 98%; padding-top: 10px; display: flex;justify-content: space-between;">
                            <div style="display: flex;flex;visibility: hidden;">
                                <div style="margin-left: 5px; margin-top: 4px; margin-right: 8px;"><input type="checkbox" :checked="allCommentsSelected" @click="SelectAllComments" /></div><div @click="SelectAllComments">Select All</div>
                            </div>
                            <div @click="deleteComments" style="color: rgb(43, 119, 155); cursor: pointer; padding: 3px 10px; font-size: 15px; font-weight: bold; margin-left: 20px;">
                                DELETE SELECTED
                            </div>
                        </div>
                    </div>
                    <div style="padding: 10px; width: 100%;">
                        <div style="width: 100%;" v-for="(commentsPerMonth, index) in metricCommentsForModal" :key="index">
                            <div style="width: 100%" v-if="showCommFor(index)">
                                <div v-if="commentsPerMonth[longMonths[index]].length" style="background-color: tomato; width: 45px; font-size: 80%; text-align: center;font-weight: bold; color: rgb(255, 255, 255); padding: 2px 8px; border-radius: 15px;">{{longMonths[index].substr(0,3).toUpperCase()}}</div>
                                <div style="width: 100%" v-for="(item, i) in commentsPerMonth" :key="i">
                                    <div style="width: 100%; padding: 10px; padding-left: 26px;" v-for="el in item" :key="el.timeStamp">
                                        <div style="display: flex; justify-content: flex-start;">
                                            <div @click="selectComment(el, index, currentCell.metric_name)" style="margin-top: 5px;margin-right: 20px;">
                                                <input type="checkbox" :checked="isCommentSelected(el, index)"/>
                                            </div>
                                            <div>
                                                <div style="color: #707070">{{ el.userEmail }}</div>
                                                <div>{{ el.comment }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top: 10px; margin-bottom: 10px; width: 95%">
                            <hr />
                        </div>
                        <div style="width: 100%">
                            <div style="padding-top: 6px; padding-bottom: 4px; font-weight: bold">Month</div>
                            <div style="width: 90%">
                                <select style="width: 70%" class="form-control" v-model="commentShowMonth">
                                    <option value="" disabled>Select Month</option>
                                    <option v-for="(item, i) in longMonths" :key="item" :value="i">{{item.charAt(0).toUpperCase() + item.slice(1)}}</option>
                                </select>
                            </div>
                            <div v-if="(String(currentUserGroups).toLowerCase().indexOf('admin') > -1 || String(currentUserGroups).toLowerCase().indexOf('poweruser') > -1)" style="padding: 12px; display: flex; justify-content: space-between; width: 98%; border: 1px solid #dcdcdc; border-radius: 8px; margin-top: 10px; height: 46px; padding-top:0; padding-left: 0;">
                                <div><input v-model="changes.currentComments.comment" style="height: 42px; border: 0; width: 340px; padding-left: 12px;" type="text" placeholder="Add Comment" /></div>
                                <div v-if="commentShowMonth" @click="addCommentsOn()" style="cursor:pointer; position: relative; right: 0px; top: 10px;">
                                    <font-awesome-icon icon="paper-plane" style="color: #2b779b; font-size: 18px;" />
                                </div>
                                <div v-if="!commentShowMonth" style="cursor:pointer; position: relative; right: -10px; top: 10px;">
                                    <font-awesome-icon icon="paper-plane" style="color: #666666; font-size: 18px;" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="false || isClearMetricEnabled">
            <div class="clear-metric-modal">
                <div>
                    <div style="display: flex; justify-content: space-between; font-weight: bold; font-size: 20px;"><div>Clear Metrics</div>
                        <div style="margin-right: 16px; cursor: pointer;" @click="handleClearMetricClick">
                            <svg class="clear-metric-close" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                            </svg>
                    </div></div>
                    <div class="clear-metric-sub-heading">NOTE: All the values in the selected metrics for the defined months will be removed.</div>
                </div>
                <div style="width: 96%">
                    <hr/>
                </div>
                <div style="width: 100%; margin-bottom: 20px;">
                    <span style="font-weight: bold;">Select Metrics</span>
                    <div style="width: 90%">
                        <div style="border: 2px solid #ececec; border-radius: 5px; height: 40px; padding: 6px; cursor: pointer;" @click="showClearMetricDropDown = !showClearMetricDropDown">
                            <span v-if="clearMetricSelection.length === 0"> Select Metrics </span>
                            <div class="clear-metric-single-selected" v-if="clearMetricSelection.length === 1"> {{clearMetricSelection.join(' ,')}} </div>
                            <div class="clear-metric-single-selected" v-if="clearMetricSelection.length > 1">{{clearMetricSelection.length}} Selected</div>
                        </div>
                        <div v-if="showClearMetricDropDown" @mouseleave="showClearMetricDropDown=false" style="display: flex; flex-direction: column; max-height: 200px; overflow: auto; z-index: 999999; box-shadow: 0px 4px 4px 2px #ccc; margin: 0 3px; position: absolute; width: 84%; background-color: #ffffff;">
                            <div style="padding: 3px 10px;" v-for="(item, index) in metricItems" :key="item" :value="item">
                                <div @click="handleClearMetricSelection(index)" style="display: flex;" class="multi-select-item">
                                    <input style="margin-top: 3px; margin-right: 8px;" type="checkbox" :checked="metricSelectedForClear(item)"/> {{item}}
                                </div>
                            </div>
                        </div>
                    </div>
                     <select v-if="false" style="width: 90%" class="form-control" v-model="clearMetricSelection">
                        <option v-for="(item) in metricItems" :key="item" :value="item">{{item}}</option>
                    </select>
                </div>
                <div style="margin-bottom: 20px; display: flex; justify-content: space-between; width: 90%;">
                    <div style="width: 50%">
                        <span style="font-weight: bold;">From</span>
                        <select style="width: 95%" class="form-control" v-model="clearMetricFromSelection">
                            <option value='' disabled selected>Select</option>
                            <option v-for="(item) in monthsArray" :key="item" :value="item">{{item}}</option>
                        </select>
                    </div>
                     <div style="width: 50%">
                         <span style="font-weight: bold;">Till</span>
                         <select style="width: 100%" :disabled="!clearMetricFromSelection" class="form-control" v-model="clearMetricToSelection">
                            <option value='' disabled selected>Select</option>
                            <option v-for="(item) in trimmedMonthsArray" :key="item" :value="item">{{item}}</option>
                        </select>
                    </div>
                </div>
                <div style="width: 90%; display: flex; visibility: hidden">
                    <input style="margin-top: 3px;" v-model="deleteAllCommentsInCM" :checked="deleteAllCommentsInCM" type="checkbox" />
                    <span style="padding-left: 6px;">Delete all comments appearing in the selected metrics.</span>
                </div>
                <div style="width: 96%">
                    <hr />
                </div>
                <div style="width: 100%">
                    <div style="margin-right: 20px; display: flex; justify-content: flex-end; align-items: center;">
                        <div>
                            <button @click="handleClearMetricClick" class="btn btn-action-arp" style="height:34px; width: 150px;">
                                Cancel
                            </button>
                        </div>
                        <div>
                            <button :disabled="!clearMetricToSelection" @click="clearMetricSubmit" class="btn btn-warning-arp" style="height: 33px; padding: 8px 20px;">
                                Clear Metrics
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="(String(currentUserGroups).toLowerCase().indexOf('admin') > -1 || String(currentUserGroups).toLowerCase().indexOf('poweruser') > -1) && showActionBar && (actionBarConfig.allowComment || actionBarConfig.allowSave || actionBarConfig.allowPost || actionBarConfig.allowEdit || actionBarConfig.allowUnPost)" @mouseleave="showActionBar = !showActionBar">
            <div class="action-bar" v-bind:style="{ position: 'absolute', top: actionBarTop, left: actionBarLeft, zIndex: '999', backgroundColor: '#ffffff', padding: '2px', fontWeight: '500', color: 'blue', fontSize: '72%', border: '1px solid #808080', display: 'flex', justifyContent: 'space-between'}">
                <div v-if="actionBarConfig.allowComment" @click="handleActionClick('comment')" style="padding: 4px; cursor: pointer;">
                    Comment
                </div>
                <div v-if="actionBarConfig.allowSave" @click="handleActionClick('save')" style="padding: 4px; cursor: pointer; border-left: 1px solid #808080;">
                    Save
                </div>
                <div v-if="actionBarConfig.allowPost" @click="handleActionClick('post')" style="padding: 4px; cursor: pointer; border-left: 1px solid #808080;">
                    Post
                </div>
                <div v-if="false && actionBarConfig.allowEdit" @click="handleActionClick('edit')" style="padding: 4px; cursor: pointer; border-left: 1px solid #808080;">
                    Edit
                </div>
                <div v-if="false && actionBarConfig.allowUnPost" @click="handleActionClick('unpost')" style="padding: 4px; cursor: pointer; border-left: 1px solid #808080; border-right: 1px solid #808080;">
                    Unpost
                </div>
                <div v-if="actionBarConfig.allowDelete" @click="handleActionClick('delete')" style="padding: 4px; cursor: not-allowed;">
                    Delete
                </div>
            </div>
        </div>
        <div v-if="showCellEdit">
            <div id="myModal" class="modal">
                <div class="modal-content">
                    <div style="width: 100%; display: flex; justify-content: space-between;">
                        <p style="font-size: 120%; font-weight: bold;">Update Value</p>
                        <div @click="renderCellEditOverlay" style="margin-right: 16px; cursor: pointer;">
                            <font-awesome-icon icon="times" style="color: #666666; font-size: 24px;" />
                        </div>
                    </div>
                    <div style="width: 100%; margin-bottom: 20px; display: flex;">
                         <div style="width: 30%">
                             <span style="font-weight: bold;">Old Value</span>
                             <input disabled v-model="newCellValue" style="border: 0; width: 90%; background-color: #ffffff;" class="form-control" type="integer" />
                        </div>
                         <div style="width: 30%">
                             <span style="font-weight: bold;">New Value</span>
                             <input style="width: 90%" v-model="inputCellValue" class="form-control" placeholder="Enter value" type="integer" />   
                        </div>
                    </div>
                    <div style="width: 100%; margin-bottom: 20px;">
                        <div style="font-weight: bold;">Comment</div>
                        <textarea v-model="changes.currentChanges.comments.comment" class="dialogTextArea" placeholder="Enter reason" rows="4" cols="50" name="comment" form="usrform"></textarea>
                    </div>
                    <div style="width: 100%">
                        <div style="margin-right: 0px; display: flex; justify-content: flex-end; align-items: center;">
                            <div>
                                <button @click="renderCellEditOverlay" class="btn btn-action-arp" style="height:34px; width: 75px;">
                                    Cancel
                                </button>
                            </div>
                            <div>
                                <button :disabled="!inputCellValue || !changes.currentChanges.comments.comment" @click="handleCellEditSave" class="btn btn-warning-arp" style="height: 33px; width: 120px; padding: 8px 20px;">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showCellUnpost">
            <div id="myModal" class="modal">
                <div class="modal-content">
                    <div style="width: 100%; display: flex; justify-content: space-between;">
                        <p style="font-size: 120%; font-weight: bold;">Unposting Value</p>
                        <div v-if="false" @click="showCellUnpost = false" style="margin-right: 16px; cursor: pointer;">
                            <font-awesome-icon icon="times" style="color: #666666; font-size: 24px;" />
                        </div>
                    </div>
                    <div style="width: 100%; margin-bottom: 20px; display: flex;">
                         You are unposting a value, please enter the reason why you would like to unpost
                    </div>
                    <div style="width: 100%; margin-bottom: 20px;">
                        <div style="font-weight: bold;">Comment</div>
                        <textarea v-model="changes.currentChanges.comments.comment" class="dialogTextArea" placeholder="Enter reason to unpost" rows="4" cols="50" name="comment" form="usrform"></textarea>
                    </div>
                    <div style="width: 100%">
                        <div style="margin-right: 0px; display: flex; justify-content: flex-end; align-items: center;">
                            <div v-if="false">
                                <button @click="showCellUnpost = false" class="btn btn-action-arp" style="height:34px; width: 75px;">
                                    CANCEL
                                </button>
                            </div>
                            <div>
                                <button :disabled="!changes.currentChanges.comments.comment.trim()" @click="handleCellUnpost" class="btn btn-warning-arp" style="height: 33px; width: 180px; padding: 8px 20px;">
                                    UNPOST VALUE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

          <div v-if="showEditedCellPost">
            <div id="myModal" class="modal">
                <div class="modal-content">
                    <div style="width: 100%; display: flex; justify-content: space-between;">
                        <p style="font-size: 120%; font-weight: bold;">Editing Value</p>
                        <div v-if="false" @click="showEditedCellPost = false" style="margin-right: 16px; cursor: pointer;">
                            <font-awesome-icon icon="times" style="color: #666666; font-size: 24px;" />
                        </div>
                    </div>
                    <div style="width: 100%; margin-bottom: 20px; display: flex;">
                        Please enter the reason why you would like to edit value
                    </div>
                    <div style="width: 100%; margin-bottom: 20px;">
                        <div style="font-weight: bold;">Comment</div>
                        <textarea v-model="changes.currentChanges.comments.comment" class="dialogTextArea" placeholder="Enter reason" rows="4" cols="50" name="comment" form="usrform"></textarea>
                    </div>
                    <div style="width: 100%">
                        <div style="margin-right: 0px; display: flex; justify-content: flex-end; align-items: center;">
                            <div v-if="false">
                                <button @click="showEditedCellPost = false" class="btn btn-action-arp" style="height:34px; width: 75px;">
                                    CANCEL
                                </button>
                            </div>
                            <div>
                                <button :disabled="!changes.currentChanges.comments.comment.trim()" @click="handleCellUnpost" class="btn btn-warning-arp" style="height: 33px; width: 180px; padding: 8px 20px;">
                                    SAVE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import { HotTable } from '@handsontable-pro/vue';
  import { mapActions, mapGetters } from 'vuex';
  import ProgramSelection from "./ProgramSelection";
  import Handsontable from 'handsontable-pro';
  import "handsontable-pro/dist/handsontable.full.css";  
  import { LICENSE_KEY } from "../Constants";
  import Vue from 'vue';

  function capitalize(s) {
    if (typeof s !== 'string') return '';
    const str = s.split(' ').map(text => text.charAt(0).toUpperCase() + text.slice(1));
    return str.join(' ');
  }

  Handsontable.renderers.registerRenderer('custom-renderer', function(hotInstance, td, row, col, prop, value, cellProperties) {
      if (!window.hotins) {
          window.hotins = hotInstance;
      }
    var column_list = ['name','target','category','in_ppm',
                                       'january','february','march','april','may','june','july','august','september','october','november','december',
                                       'january_status','february_status','march_status','april_status','may_status','june_status','july_status','august_status','september_status','october_status','november_status','december_status',
                                       'january_target_acheived','february_target_acheived','march_target_acheived','april_target_acheived','may_target_acheived','june_target_acheived','july_target_acheived','august_target_acheived','september_target_acheived','october_target_acheived','november_target_acheived','december_target_acheived',
                                       'metric_comments']
                    
    var month_list = ['january','february','march','april','may','june','july','august','september','october','november','december']
    var column = column_list[col]
    if(['name','category','in_ppm'].indexOf(column) > -1){
        td.style.background = "#f8f9fa"
        cellProperties.readOnly = true;
        column === 'name' && (cellProperties.width = window.innerWidth/20 * 4.75) && (td.setAttribute('class', 'td-name')) && (console.log("row at custom render --", td, row, prop));
        column === 'category' && (cellProperties.width = window.innerWidth/20 * 1.8);
        column === 'in_ppm' && (cellProperties.width = window.innerWidth/20 * 0.7) && (td.style.textAlign = 'center');
        td.innerHTML = `${value}`
    }
    else if(column == "target"){
        td.style.background = "#eee"
        cellProperties.readOnly = true;
        cellProperties.width = (window.innerWidth/20 * 0.7);
        var targetValue = []
        var title = "";

        if(value){
            let previosVal = NaN;
            for (var i = 0; i < value.length; i++) {
                targetValue.push(value[i]['value']);
                if (previosVal !== (+value[i]['value'])) {
                    if (i !== 0) {
                        title += `to ${capitalize(value[i-1]['end'])} \n`;
                    }
                    title += `${value[i]['value']} from ${capitalize(value[i]['start'])} `;
                    previosVal = (+value[i]['value']);
                }
            }

            title += `to ${capitalize(value[value.length - 1]['end'])}`;
        }
        
        td.innerHTML = `<div title="${title}">${String(targetValue)}</div>`
    }
    else if(column == "metric_comments"){
        if(value[0] == "no comments" || value.length == 0){
            let nameTd = document.getElementsByClassName('td-name')[row];
            // console.log('qqqqqqqqqqqqq', row, nameTd);
            if (nameTd && nameTd.getElementsByClassName("red-tick-td")[0]) {
                nameTd.removeChild(nameTd.childNodes[0])
            }
            // var buttonText = "No Comments"
            // td.style.background = "#eee"
            // td.innerHTML = `<div> </div>`
        } else {
            let nameTd = document.getElementsByClassName('td-name')[row];
            // console.log('qqqqqqqqqqqqq', row, nameTd);
            if (nameTd && !nameTd.getElementsByClassName("red-tick-td")[0]) {
                let g = document.createElement('div');
                g.setAttribute("class", "red-tick-td");
                g.style.right = (-((window.innerWidth/20 * 4.75) - 25)).toString() + "px";
                nameTd.appendChild(g)
            }
            cellProperties.width = 0;
            td.style.width = 0;
            // td.style.background = "#f4bc42"
            // td.innerHTML = `<div><b>C</b></div>`
            
        }
    }
    else if(month_list.indexOf(column) > -1 ){
        cellProperties.width = window.innerWidth/20 * 1;
        value = hotInstance.getDataAtCell(row,col)
        td.innerHTML = `${value}`   
        var status_col = col +12;
        var target_achieved_col = col + 24;
        var status = hotInstance.getDataAtCell(row,status_col)
        var target_achieved = hotInstance.getDataAtCell(row,target_achieved_col)
        var access_level = cellProperties.access_level
        if (hotInstance.getDataAtCell(row, 40)[0] !== "no comments") {
            let comments = hotInstance.getDataAtCell(row, 40);
            let flag = false;
            comments.forEach(i => {
                if (i && i.period && i.period.toLowerCase().startsWith(column.toLowerCase())) {
                    flag = true;
                }
            });
            if (flag) {
                td.setAttribute('class', 'td-name-months');
            }
             let nameTd = [];
             nameTd = document.getElementsByClassName('td-name-months');
             let arr = [];
             [].push.apply(arr, nameTd);
             const numVal = hotInstance.getDataAtCell(row,col);
             (arr.length > 0) && arr.forEach(el => {
                 if (el.getElementsByClassName("red-tick-td-months").length === 0) {
                    let g = document.createElement('div');
                    numVal == "" && (g.style.top = '0px') && (g.style.height = '21px')
                    g.style.left = (window.innerWidth/20 - 20).toString() + 'px';
                    g.setAttribute("class", "red-tick-td-months");
                    el.appendChild(g);
                 }
             });
        }
        
        if(String(target_achieved).toLowerCase() == "-1"){
            td.style.color = "#f00"
        }

        if(status == "unposted"){
            td.style.background = "#eddb55";
            if(['admin','poweruser'].indexOf(access_level) < 0 ){
                
                cellProperties.readOnly = true;
            }
        }
        else if(status == "posted"){
            td.style.background = "#d7d8d6";
            if(access_level != "admin"){
                cellProperties.readOnly = true
            }
        }else if(status == "saved"){
            td.style.background = "#9df2aa";
            if(['admin','poweruser'].indexOf(access_level) < 0 ){
                // console.log(access_level)
                cellProperties.readOnly = true;
            }
        } else if(status == "empty"){
            if (td.textContent && td.textContent.trim()) {
                td.style.border = "1px solid #333";
            }
            if(['admin','poweruser'].indexOf(access_level) < 0 ){
                cellProperties.readOnly = true;
            }
        }
    }
    
    
    return td
    Handsontable.renderers.TextRenderer.apply(this, arguments);
  })

  export default {
    name: "MetricDataTable2",
    props: ['metricData','jsonData'],
    methods: {
        ...mapActions(['getData','updateDB','resetOverlay','updateOverlayParams']),
        onParamsChange() {
            this.$emit('paramsChange');
            // this.unMountSelection();
        },
        beforeChange(changes, source){
            if(source === 'loadData' || source === 'programatic'){
                return true    
                }
            else {
                if(changes[0][2] != changes[0][3]) {
                    console.log("beforeChange hook...", this.metricData)
                    var htTable =  this.$refs.hotTableComponent.hotInstance.getInstance();
                    var physicalIndex = htTable.toPhysicalRow(changes[0][0]);
                    this.changes.currentChanges.row = changes[0][0]
                    this.changes.currentChanges.column = changes[0][1]
                    this.changes.currentChanges.beforeValue = changes[0][2]
                    this.changes.currentChanges.afterValue = changes[0][3]
                    this.changes.currentChanges.name = this.currentFormatedData[physicalIndex]['name']
                    this.changes.currentChanges.status = this.currentFormatedData[physicalIndex][`${changes[0][1]}_status`]
                    // this.changes.currentChanges.status = this.jsonData['tracked_metrics'][this.changes.currentChanges.name]['metric_values'][this.changes.currentChanges.column]['status']
                    console.log(`Change attempt. Metric ${this.changes.currentChanges.name}, 
                                    Month ${this.changes.currentChanges.column}, 
                                    before ${this.changes.currentChanges.beforeValue}, 
                                    after ${this.changes.currentChanges.afterValue},
                                    status ${this.changes.currentChanges.status}`)
                    /*if(this.changes.currentChanges.status == "posted" || this.changes.currentChanges.status == "unposted"){
                        this.changes.currentChanges.needsComments = "true"
                        this.commentsModalShow = !this.commentsModalShow;
                        return false
                    }else {
                        this.changes.currentChanges.needsComments = "false"
                    }*/
                    if(this.changes.currentChanges.status == "saved" || this.changes.currentChanges.status == "posted"){
                        this.savedItems.list = this.savedItems.list.filter(entry => !((entry.metric_name == this.changes.currentChanges.name) && (entry.month == this.changes.currentChanges.column)))
                    }
                    if(this.changes.currentChanges.status == "posted" && this.changes.currentChanges.afterValue.length < 1 ) {
                        this.showCellUnpost = true;
                    }

                    if(this.changes.currentChanges.status == "posted" &&  this.changes.currentChanges.afterValue.length > 0 ) {
                        this.showEditedCellPost = true;
                    }

                    if(this.changes.currentChanges.status == "unposted" &&  this.changes.currentChanges.afterValue.length > 0 ) {
                        this.showEditedCellPost = true;
                    }

                    this.handleSubmit()
                    return false
                }else {
                    return false
                }
            }   
            },
        handleModalClick(e) {
            window.eee = e;
            e && e.preventDefault();
            if (e && e.target.className === "modal") {
                this.metricCommentsModalShow = false;
                this.addCommentsModalShow = false;
            }
        },
        clearComments(){
            this.changes.currentChanges =  {
                    row: "",
                    column: "",
                    name: "",
                    beforeValue: "",
                    afterValue: "",
                    status: "",
                    comments: {
                        "comment":"",
                        "timeStamp":"",
                        "userEmail":""
                        },
                    }
                
            },
        clearAddComments(){
            this.changes.currentComments = {
                    comment: "",
                    userEmail: "",
                    timeStamp: ""
                }
        },
        handleOk (evt) {
            // Prevent modal from closing
                evt.preventDefault()
                if (!this.changes.currentChanges.comments.comment || (this.changes.currentChanges.comments.comment.length < 5)) {
                    if(this.changes.currentChanges.needsComments == "true"){
                        this.updateOverlayParams({
                            display: 'block',
                            message: 'Please enter the reason for the updating the values at least 5 characters',
                            // specialClassNames: 'download-in-progress',
                            isNotification: false,
                            buttons: {
                                type: 'alert',
                                successHandler: () => {}
                            },
                            specialClassNames: 'delete-comment',
                            duration: '',
                            displayCloseIcon: true,
                            background: true
                        });
                    } else {
                        this.handleSubmit()
                    }
                } else {
                    this.handleSubmit()
                }
            },
        handleSubmit () {
                var proceed = false
                if(this.changes.currentChanges.needsComments == "true"){
                    if(this.changes.currentChanges.comments.comment.length >= 5){
                        proceed = true
                    }
                } else {
                    proceed = true
                }
                if(proceed){
                    console.log("+++++++++++++++++", proceed);
                    this.$refs.hotTableComponent.hotInstance.setDataAtRowProp(this.changes.currentChanges.row,this.changes.currentChanges.column,this.changes.currentChanges.afterValue,"programatic")
                    console.log("+++++++++++=", this.changes.currentChanges.afterValue);
                    this.changes.currentChanges.comments.timeStamp = Date().toLocaleString("en-us")
                    this.changes.currentChanges.comments.userEmail = this.currentUserEmail
                    this.changes.unsavedChanges = this.changes.unsavedChanges.filter(entry => !((entry.name == this.changes.currentChanges.name) && (entry.column == this.changes.currentChanges.column)))
                    this.changes.unsavedChanges.push(this.changes.currentChanges)
                    this.clearComments()
                    // this.$refs.commentsModal.hide()
                    }
                },  
        saveChanges(){
            var validation = this.validateSaveChanges()
            console.log(`logging saveChanges() validation: ${JSON.stringify(validation)}`)
            this.selectInputPostModal = false;
            this.selectInputSaveModal = false;
            if(validation['status'] == true){
                this.shouldDeleteComments().then(data => {
                    console.log(`Save Channges got triggered with content: ${JSON.stringify(this.savedItems.toBeSaved)}`)
                    this.saveModalShow = !this.saveModalShow;
                    this.updateDB({type:"save",body:{...this.savedItems.toBeSaved, deletedComments: data}});
                });              
                
            } else {
                this.updateOverlayParams({
                    display: 'block',
                    message: validation['message'],
                    // specialClassNames: 'download-in-progress',
                    isNotification: false,
                    buttons: {
                        type: 'alert',
                        successHandler: () => {}
                    },
                    specialClassNames: 'delete-comment',
                    duration: '',
                    displayCloseIcon: true,
                    background: true
                });
            }

        },
        addToSave(item,event){
            console.log(`Logging Current Saved Items Obj ${JSON.stringify(this.savedItems.toBeSaved,null,2)}`)
           // console.log(`event: ${JSON.stringify(item,null,2)} item: ${event}`)
           // this.savedItems.toBeSaved.push(item)
            
            },
        postChanges(){
            var validation = this.validatePostChanges();
            this.selectInputPostModal = false;
            this.selectInputSaveModal = false;
            console.log(`logging postChanges() validation: ${JSON.stringify(validation)}`)
            if(validation['status'] == true){
                console.log(`Post Changes got triggered with content: ${this.postedItems.toBeSaved}`)
                this.shouldDeleteComments().then(data => {
                    this.postModalShow = !this.postModalShow;
                    this.updateDB({type:"post",body:{...this.postedItems.toBePosted, deletedComments: data}});
                });
            } else {
                this.updateOverlayParams({
                    display: 'block',
                    message: validation['message'],
                    // specialClassNames: 'download-in-progress',
                    isNotification: false,
                    buttons: {
                        type: 'alert',
                        successHandler: () => {}
                    },
                    specialClassNames: 'delete-comment',
                    duration: '',
                    displayCloseIcon: true,
                    background: true
                });
            }
            
            },
        addToPost(item,event){
            console.log(`Logging Current posted Items Obj ${JSON.stringify(this.postedItems.toBePosted,null,2)}`)
           // console.log(`event: ${JSON.stringify(item,null,2)} item: ${event}`)
           // this.savedItems.toBeSaved.push(item)
            },
        validatePostChanges(){
            console.log(`validatePostChanges() toBePosted.savedItems: ${this.postedItems.toBePosted.savedItems} and tobePosted.unsavedChanges: ${this.postedItems.toBePosted.unsavedChanges}`)
            if(this.postedItems.toBePosted.savedItems.length == 0 && this.postedItems.toBePosted.unsavedChanges.length == 0){
                return {'status':false,'message':'Nothing selected to post'}
            } else {
                return {'status': true}
            }
        },
        validateSaveChanges(){
            if(this.savedItems.toBeSaved.unsavedChanges.length == 0 && this.savedItems.toBeSaved.unsavedComments.length == 0){
                return {'status':false,'message':'Nothing selected to save'}
            } else {
                return {'status': true}
            }
        },
        deSelectAll(type){
            if(type == "post"){
                this.postedItems.toBePosted.savedItems = []
                this.postedItems.toBePosted.unsavedChanges = []
            }
            else if(type == 'save'){
                this.savedItems.toBeSaved.unsavedChanges = []
                this.savedItems.toBeSaved.unsavedComments = []
                this.clearDeleteComments();
            }
            else if(type == "comment") {
                this.clearDeleteComments();
            }
        },
        selectAll(type){
            if(type == 'post'){
                this.postedItems.toBePosted.savedItems = []
                var array = this.savedItems.list
                for (var i in array){
                    this.postedItems.toBePosted.savedItems.push(array[i])
                    }
                this.postedItems.toBePosted.unsavedChanges = []
                var array2 = this.changes.unsavedChanges
                for (var i in array2){
                    this.postedItems.toBePosted.unsavedChanges.push(array2[i])
                }
            }
            else if(type == "save"){
                var array = this.changes.unsavedChanges
                this.savedItems.toBeSaved.unsavedChanges = []
                for (var i in array){
                    this.savedItems.toBeSaved.unsavedChanges.push(array[i])
                    }
                var array2 = this.changes.unsavedComments
                this.savedItems.toBeSaved.unsavedComments = []
                for (var i in array2){
                    this.savedItems.toBeSaved.unsavedComments.push(array2[i])
                }
            }
            else if(type == "comment") {
                console.log("selet all ", this.metricCommentsForModal);
                this.metricCommentsForModal.forEach((c,i) => {
                    let comArray = this.metricCommentsForModal[i][this.longMonths[i]];
                    this.selectedCommentsArray[i][this.longMonths[i]] = [...comArray];
                });
                //this.selectedCommentsArray = {...this.metricCommentsForModal};

            }
        },
        renderCellEditOverlay: function() {
            this.showCellEdit ? (this.showCellEdit = false) : (this.showCellEdit = true);
            this.showCellEdit && (this.inputCellValue = "");
        },
        handleCellEditSave: function() {
            //this.addComments();
            this.showEditedCellPost = false;
            var month_list = ['january','february','march','april','may','june','july','august','september','october','november','december']
            this.renderCellEditOverlay();
            const colVal = (month_list.indexOf(this.currentCell.col)+4);
            var htTable =  this.$refs.hotTableComponent.hotInstance.getInstance();
            var physicalIndex = htTable.toPhysicalRow(this.currentCell.row);
            this.$refs.hotTableComponent.hotInstance.setDataAtCell(physicalIndex, colVal, Number(this.inputCellValue));
            //this.hotSettings.data[this.currentCell.row][this.currentCell.col] = this.newCellValue;
        },
        renderCellEditOverlay: function() {
            this.showCellEdit ? (this.showCellEdit = false) : (this.showCellEdit = true);
            this.showCellEdit && (this.inputCellValue = "");
        },
        handleCellEditSave: function() {
            //this.addComments();
            this.showEditedCellPost = false;
            var htTable =  this.$refs.hotTableComponent.hotInstance.getInstance();
            var physicalIndex = htTable.toPhysicalRow(this.currentCell.row)
            var month_list = ['january','february','march','april','may','june','july','august','september','october','november','december']
            this.renderCellEditOverlay();
            const colVal = (month_list.indexOf(this.currentCell.col)+4);
            this.$refs.hotTableComponent.hotInstance.setDataAtCell(physicalIndex, colVal, Number(this.inputCellValue));
            //this.hotSettings.data[this.currentCell.row][this.currentCell.col] = this.newCellValue;
        },
        handleCellUnpost() {
            //this.addComments();
            this.showCellUnpost = false;
            this.showEditedCellPost = false;
            var month_list = ['january','february','march','april','may','june','july','august','september','october','november','december'];
            const colVal = (month_list.indexOf(this.currentCell.col)+4);
            let targetIndex = [];
            if (this.isClearMetricEnabled) {
                const targetChangeCollection = this.changes.unsavedChanges.filter((e, index) => {
                    if (e.beforeValue && !e.afterValue && this.clearMetricSelection.indexOf(e.name) > -1 && e.status === "posted" && !e.comments.comment) {
                        targetIndex.push(index);
                        return true;
                    } else {
                        return false;
                    }
                });
            } else {
                targetIndex.push(this.changes.unsavedChanges.length - 1);
            }
            targetIndex.forEach((targetChange, i) => {
                let obj = this.changes.unsavedChanges[targetChange]
                this.changes.currentChanges.comments.timeStamp = Date().toLocaleString("en-us")
                this.changes.currentChanges.comments.userEmail = this.currentUserEmail
                obj.comments = {...this.changes.currentChanges.comments}
                this.changes.unsavedChanges[targetChange] = {...obj};
            });
            this.clearMetricFromSelection = '';
            this.clearMetricToSelection = '';
            this.clearMetricSelection = [];
            this.deleteAllCommentsInCM = false;
            this.clearComments();
            this.disposeClearMetricClick();
        },
        afterCellSelection: function(row, prop, row2, prop2, preventScrolling, selectionLayerLevel){
            this.showActionBar = false;
            // console.log(row2, prop2)
            this.currentCell.row = row;
            this.currentCell.col = prop;
            this.currentCell.value = this.$refs.hotTableComponent.hotInstance.getDataAtRowProp(row,prop)
            this.currentCell.metric_name = this.$refs.hotTableComponent.hotInstance.getDataAtRowProp(row,"name")
            this.changes.currentComments.comment = ""
            if(!(["name","target_array","category","in_ppm","metric_comments"].indexOf(this.currentCell.col)>-1)){
                this.currentCell.canComment = true
                }
            else {
                this.currentCell.canComment = false
            }
            this.newCellValue = this.currentCell.value;
            const colVal = `${prop}_status`;
            this.actionMenuToRender = [];
            this.currentCell.status = this.hotSettings.data[row][colVal];
            if (this.currentCell.canComment) {
                if (this.hotSettings.data[row][colVal] === "posted") {
                    // this.renderCellEditOverlay();
                    this.actionBarConfig.allowSave = false;
                    this.actionBarConfig.allowPost = false;
                    this.actionBarConfig.allowComment = true;
                    this.actionBarConfig.allowDelete = false;
                    this.actionBarConfig.allowEdit = false;
                    this.actionBarConfig.allowUnPost = false;
                    const month_list = ['january','february','march','april','may','june','july','august','september','october','november','december']
                    const colVal = (month_list.indexOf(this.currentCell.col)+1);
                    this.actionBarLeft = ((window.innerWidth/20)*7 + ((window.innerWidth/20)*1 * colVal)).toString() + 'px';
                    setTimeout(() => {
                        this.showActionBar = true;
                        let tdd = document.getElementsByClassName('current highlight')[0];
                        console.log('tttdddddddddddd===', tdd)
                        this.actionBarTop = (tdd.getBoundingClientRect().y - 95).toString() + 'px';
                        this.actionBarLeft = (tdd.getBoundingClientRect().x).toString() + 'px';
                    }, 40);
                } else {
                    this.actionBarConfig.allowEdit = false;
                    this.actionBarConfig.allowUnPost = false;
                    let unsavedChanges = this.changes.unsavedChanges.filter(i => i.row === this.currentCell.row && i.column === this.currentCell.col);
                    let unsavedComments = this.changes.unsavedComments.filter(i => i.metric_name === this.currentCell.metric_name && i.month === this.currentCell.col);
                    let savedItems = this.savedItems.list.filter(i => i.metric_name === this.currentCell.metric_name && i.month === this.currentCell.col);
                    
                    this.actionBarConfig.allowSave = unsavedComments[0] || unsavedChanges[0];
                    this.actionBarConfig.allowPost = savedItems && savedItems[0];
                    this.actionBarConfig.allowComment = true/* (this.currentCell.value || "").toString().length > 0 */;
                    this.actionBarConfig.allowDelete = false;
                    const month_list = ['january','february','march','april','may','june','july','august','september','october','november','december']
                    const colVal = (month_list.indexOf(this.currentCell.col)+1);
                    this.actionBarLeft = ((window.innerWidth/20)*7 + ((window.innerWidth/20)*1 * colVal)).toString() + 'px';
                    setTimeout(() => {
                        this.showActionBar = true;
                        let tdd = document.getElementsByClassName('current highlight')[0];
                        console.log('tttdddddddddddd===', tdd)
                        this.actionBarTop = (tdd.getBoundingClientRect().y - 95).toString() + 'px';
                        this.actionBarLeft = (tdd.getBoundingClientRect().x).toString() + 'px';
                    }, 40);
                }
            }
        },
        addCommentButtonFunc: function(){
            this.showActionBar = false;
            if(this.currentCell.canComment){
                this.addCommentsModalShow = !this.addCommentsModalShow
                }
            },
        handleCommentsOk(event){
            event.preventDefault()
            
            if((!this.changes.currentComments.comment.length || this.changes.currentComments.comment.length <= 4)){
                this.updateOverlayParams({
                    display: 'block',
                    message: 'Please enter atleast 5 characters in the comments',
                    // specialClassNames: 'download-in-progress',
                    isNotification: false,
                    buttons: {
                        type: 'alert',
                        successHandler: () => {}
                    },
                    specialClassNames: 'delete-comment',
                    duration: '',
                    displayCloseIcon: true,
                    background: true
                });
            } else {
                this.addComments()
            }
            
        },    
        addComments: function(){
            if (this.changes.currentComments.comment.length <= 5) {
                 Vue.notify({
                 group: 'error',
                 text: 'Please enter atleast 5 characters in the comments section',
                 closeOnClick:true
               })
                return;
            }
            var obj = {}
            obj['metric_name'] = this.currentCell.metric_name;
            obj['month'] = this.currentCell.col;
            obj['value'] = this.currentCell.value;
            obj['comment'] = this.changes.currentComments.comment;
            obj['userEmail'] = this.currentUserEmail
            obj['timeStamp'] = Date().toLocaleString("en-us")
            this.changes.unsavedComments.push(obj)
            this.clearAddComments()
            // this.$refs.addCommentsModal.hide()
            },
        addCommentsOn: function() {
            console.log("0909", this.currentCell, this.commentShowMonth)
            if (this.changes.currentComments.comment.length <= 5) {
                 Vue.notify({
                 group: 'error',
                 text: 'Please enter atleast 5 characters in the comments section',
                 closeOnClick:true
               })
                return;
            }
            var obj = {}
            obj['metric_name'] = this.currentCell.metric_name;
            obj['month'] = this.longMonths[this.commentShowMonth];
            obj['comment'] = this.changes.currentComments.comment;
            obj['userEmail'] = this.currentUserEmail
            obj['timeStamp'] = Date().toLocaleString("en-us")
            this.changes.unsavedComments.push(obj)
            this.clearAddComments()
        },
        metricCommentsFunc: function(row, hideAllCommentsView = false){
            let rowHydrated = false;
            this.hotSettings.data.forEach((obj, i) => {
                if (!rowHydrated && obj.name === (this.$refs.hotTableComponent.hotInstance.getData()[row] && this.$refs.hotTableComponent.hotInstance.getData()[row][0])) {
                    rowHydrated = true;
                    row = i;
                }
            });
            console.log("========== row", row)
                let hasComments = false;
                var month_list = ['january','february','march','april','may','june','july','august','september','october','november','december'];
                let metricCommentsForMonths = [];
                month_list.forEach(m => {
                    let currentComments = [];
                    this.currentFormatedData[row] && (currentComments = this.currentFormatedData[row]['metric_comments'].filter(i => i.period === m));
                    let obj = {};
                    if (currentComments.length > 0) {
                        currentComments = currentComments.map(e => {
                        return {...e, metric_name: this.hotSettings.data[row].name}
                    });
                        hasComments = true;
                    } else {
                        this.metricCommentsModalShow = false;
                        this.commentShowMonth = "";
                        this.clearDeleteComments();
                    }
                    obj[m] = currentComments;
                    metricCommentsForMonths.push(obj);
                });
                this.currentFormatedData[row] && (this.renderCommentsFor = this.currentFormatedData[row]['name'])
                this.metricCommentsForModal = metricCommentsForMonths; // this.currentFormatedData[row]['metric_comments']
                console.log(JSON.stringify(this.currentFormatedData,null,2));
                if (hasComments && !hideAllCommentsView) {
                    this.metricCommentsModalShow = true;
                    this.commentShowMonth = "";
                    this.clearDeleteComments();
                } else if (hideAllCommentsView) {
                    this.clearDeleteComments();
                    this.addCommentsModalShow = true
                }
            },
        handleSelectionEdit: function() {
            this.renderSelection = true;
            },
        renderHelpSection: function() {
            this.showHelpMenu = true;
            this.showActionBar = false;
        },
        closeHelpMenu: function() {
            this.showHelpMenu = false;
        },
        unMountSelection: function() {
            this.renderSelection = false;
            },
        handleClearMetricClick: function() {
            this.showActionBar = false;
            if (this.isClearMetricEnabled) {
                this.isClearMetricEnabled = false;
            } else {
                let metricItems = this.$refs.hotTableComponent.hotInstance.getData().map(i => i[0]);
                this.metricItems = [...metricItems];
                this.isClearMetricEnabled = true;
            }
        },
        disposeClearMetricClick: function() {
            this.showActionBar = false;
            if (this.isClearMetricEnabled) {
                this.isClearMetricEnabled = false;
            } 
        },

        clearDeleteComments: function() {
            this.selectedCommentsArray = new Array(12).fill(0).map(() => new Array(0));
        },
        toggleFullScreen: function () {
            const el = document.getElementById('main-content-view');
            if (el.style.position === 'absolute') {
                this.expandMode = false;
                el.style.position = '';
                this.tableHeight = window.innerHeight - 180 + "px";
            } else {
                this.expandMode = true;
                el.style.position = 'absolute';
                el.style.top = 0;
                this.tableHeight = window.innerHeight - 0 + "px";
            }
        },
        handleDiscard: function() {
            const _this = this;
            this.showActionBar = false;
            this.updateOverlayParams({
                    display: 'block',
                    title: 'Discard Changes',
                    message: `All the changes will be lost. Are you sure you want to discard without saving?`,
                    isNotification: false,
                    buttons: {
                        type: 'discard-challenge',
                        successHandler: () => {
                            this.clearMetricFromSelection = '';
                            this.clearMetricToSelection = '';
                            this.clearMetricSelection = [];
                            this.deleteAllCommentsInCM = false;
                            this.clearDeleteComments();
                           _this.getData();
                           document.getElementById('myModal').style.display = "none";
                           _this.resetOverlay();
                        }

                    },
                    specialClassNames: 'delete-comment discard-sp-width',
                    duration: '',
                    displayCloseIcon: true,
                    background: true
                });
        },
        saveSelectHandler: function() {
            if (!this.selectInputSaveModal) {
                this.selectAll('save');
                this.selectInputSaveModal = true;
            } else {
                this.selectInputSaveModal = false;
                this.deSelectAll('save');
            }
        },
        shouldDeleteComments: function() {
            return new Promise(res => {
                let deletedComments = [];
                this.selectedCommentsArray.forEach((e, i) => {
                if (e[this.longMonths[i]] && e[this.longMonths[i]].length > 0) {
                   e[this.longMonths[i]].forEach(c => {
                       let obj = {};
                       obj.metric_name = c.metric_name;
                       obj.comment_uuid = c.uuid;
                       deletedComments.push(obj);
                   });
                }
            });
            res(deletedComments);
            });
        },
        deleteCommentsConfirm: function() {
            let selectedCommentsCount = 0;
            let deletedComments = [];
            this.selectedCommentsArray.forEach((el, index) => {
                if(el[this.longMonths[index]]) {
                    el[this.longMonths[index]].forEach(c => {
                        selectedCommentsCount = selectedCommentsCount++;
                    });
                }
            });
            this.selectedCommentsCount = selectedCommentsCount;
            this.selectedCommentsArray.forEach((e, i) => {
                if (e[this.longMonths[i]] && e[this.longMonths[i]].length > 0) {
                   e[this.longMonths[i]].forEach(c => {
                       let obj = {};
                       obj.metric_name = c.metric_name;
                       obj.comment_uuid = c.uuid;
                       deletedComments.push(obj);
                   });
                }
            });
            if (deletedComments.length > 0) {
              this.updateDB({type:"save", isDeleteRequest: true, body: { deletedComments, unsavedChanges: [], unsavedComments: [] }});
              // hide delte
              this.metricCommentsModalShow = false;
              this.addCommentsModalShow = false;
              this.allCommentsSelected = false;
            } else {
              Vue.notify({
                group: 'error',
                text: 'Please select a comment to delete',
                closeOnClick:true
              })
              return;
            }
        },
        deleteComments: function() {
            let deletedCommentsCount = 0;
            this.selectedCommentsArray.forEach((e, i) => {
                if (e[this.longMonths[i]] && e[this.longMonths[i]].length > 0) {
                   e[this.longMonths[i]].forEach(c => {
                       deletedCommentsCount++;
                   });
                }
            });

            this.updateOverlayParams({
                    display: 'block',
                    title: `Delete Comment${deletedCommentsCount > 1 ? 's' : ''}`,
                    message: `Are you sure you want to delete selected comment${deletedCommentsCount > 1 ? 's' : ''}?`,
                    isNotification: false,
                    buttons: {
                        type: 'challenge',
                        successHandler: () => {
                            this.deleteCommentsConfirm();
                            this.resetOverlay();
                        }
                    },
                    specialClassNames: 'delete-comment delete-modal',
                    duration: '',
                    displayCloseIcon: true,
                    background: true
                });
        },
        SelectAllComments: function() {
            if (!this.allCommentsSelected) {
                // do select based on meric name selection TODO
                this.selectAll('comment');
                this.allCommentsSelected = true;
            } else {
                this.allCommentsSelected = false;
                this.deSelectAll('comment');
            }
        },
        showCommFor(i) {
            console.log("show comms for index ", i == this.commentShowMonth)
            if (this.commentShowMonth !== "" &&  this.commentShowMonth >= 0) {
                return (i == this.commentShowMonth)
            } else {
                return true;
            }
        },
        showCommForSpecificMonth(i) {
            this.showActionBar = false;
            console.log(i, this.longMonths[i] , this.currentCell)
            return (this.longMonths[i] === this.currentCell.col);
        },
        selectComment(el, i, metricName) {
            let counter = 0;
            if (false) {
                let comments = this.selectedCommentsArray[i][this.longMonths[i]].filter(com => com.uuid != el.uuid);
                this.selectedCommentsArray[i][this.longMonths[i]] = comments;
                const data = {...this.selectedCommentsArray};
                this.selectedCommentsArray = {...data};
                // this.metricCommentsForModal = {...this.metricCommentsForModal};
                return;
            }
            console.log(el, i);
            if (this.selectedCommentsArray[i] && this.selectedCommentsArray[i][this.longMonths[i]] && this.selectedCommentsArray[i][this.longMonths[i]].length > 0) {
                // comments avl in selected month.
                let comments = this.selectedCommentsArray[i][this.longMonths[i]];
                let shouldDel = false;
                // add if needed or delete
                comments.forEach(com => {
                    counter++;
                    if(com.comment == el.comment && com.userEmail == el.userEmail && com.period == el.period){
                    // if (com.uuid === el.uuid) {
                        shouldDel = true;
                    }
                });
                if (shouldDel) {
                    counter--;
                    let filteredComments = [];
                    filteredComments = comments.filter(com => com.uuid != el.uuid);
                    comments = [];
                    comments = [...filteredComments];
                } else {
                    counter++;
                    comments.push({...el, metric_name: metricName});
                }
                this.selectedCommentsArray[i][this.longMonths[i]] = [...comments];
            } else {
                let comments = this.selectedCommentsArray && this.selectedCommentsArray[i] && this.selectedCommentsArray[i][this.longMonths[i]];
                if (!comments) {
                    comments = [];
                }
                let el_com = {...el, metric_name: metricName}
                counter++;
                comments.push(el_com);
                this.selectedCommentsArray && this.selectedCommentsArray[i] && (this.selectedCommentsArray[i][this.longMonths[i]] = [...comments]);
            }
            this.selectedCommentsArray = [...this.selectedCommentsArray];
            this.deleteCommentSelectionCount = counter;
        },
        isCommentSelected(el, i) {
            console.log(" is com sel", this.selectedCommentsArray[this.longMonths[i]])
            if (this.selectedCommentsArray[i] && this.selectedCommentsArray[i][this.longMonths[i]] && this.selectedCommentsArray[i][this.longMonths[i]].length > 0) {
                let comments = this.selectedCommentsArray[i][this.longMonths[i]];
                let flag = false;
                console.log('=', comments)
                comments.forEach(com => {
                    if(com.comment == el.comment && com.userEmail == el.userEmail && com.period == el.period){
                        flag = true;
                    }
                });
                console.log("----", flag)
                return flag;
            } else {
                return false;
            }
        },
         postSelectHandler: function() {
            if (!this.selectInputPostModal) {
                this.selectAll('post');
                this.selectInputPostModal = true;
            } else {
                this.selectInputPostModal = false;
                this.deSelectAll('post');
            }
        },
        metricSelectedForClear(targetItem) {
            if (this.clearMetricSelection.indexOf(targetItem) <= -1) {
                return false;
            }
            return true;
        },
        handleClearMetricSelection(index) {
            const targetItem = this.metricItems[index];
            if (this.clearMetricSelection.indexOf(targetItem) <= -1) {
                this.clearMetricSelection.push(targetItem)
            } else {
                this.clearMetricSelection = this.clearMetricSelection.filter(i => i !== targetItem)
            }
        },
        clearMetricSubmit(e) {
            let _this = this;
            this.updateOverlayParams({
                display: 'block',
                title: 'Clear Metrics',
                message: `All the value stored in the selected metrics will be lost. Are you sure you want to clear metrics?`,
                isNotification: false,
                buttons: {
                    type: 'clear-metrics-challenge',
                    successHandler: () => {
                    const fromIndex = _this.monthsArray.indexOf(_this.clearMetricFromSelection) + 4;
                    const toIndex = _this.monthsArray.indexOf(_this.clearMetricToSelection) + 4;
                    let targetRows = [];
                    _this.$refs.hotTableComponent.hotInstance.getData().forEach((item, index) => {
                        if (_this.clearMetricSelection.indexOf(item[0]) > -1) {
                            // targetRows.push(_this.$refs.hotTableComponent.hotInstance.toPhysicalRow(index));
                            targetRows.push(index); // index is wrt data (unfil)
                            if (this.deleteAllCommentsInCM && /**/ this.$refs.hotTableComponent.hotInstance.getData()[index][40].length > 0) {
                                this.$refs.hotTableComponent.hotInstance.getData()[index][40].forEach(e => {
                                    if (e && e.period && this.longMonths.indexOf(e.period.toLowerCase()) > -1 ) {
                                        const targetPeriod = this.longMonths.indexOf(e.period.toLowerCase());
                                        if (targetPeriod >= (fromIndex - 4) && targetPeriod <= (toIndex - 4)) {
                                            this.selectComment(e, this.longMonths.indexOf(e.period), item[0]);
                                        }
                                    }
                                })
                            }
                        }
                    });
                    console.log("rows....", targetRows, fromIndex, toIndex)
                    targetRows.forEach(row => {
                        // console.log('00000000', row)
                        let i;
                        for(i=fromIndex; i<=toIndex; i++) {
                            _this.$refs.hotTableComponent.hotInstance.setDataAtCell(row, i, "");
                            
                        }
                    });
                    _this.resetOverlay();
                    // this.clearComments();
                    this.$notify({
                        group: 'success',
                        text: 'Cleared Metrics...',
                        closeOnClick:true
                    });
                    let hasPostedChanges = false;
                    setTimeout(() => {
                        this.changes.unsavedChanges.forEach(e => {
                            if (e.status === "posted") {
                                hasPostedChanges = true;
                            }
                        });
                        console.log("-----------", hasPostedChanges)
                        if (!hasPostedChanges) {
                            _this.clearMetricFromSelection = '';
                            _this.clearMetricToSelection = '';
                            _this.clearMetricSelection = [];
                            _this.deleteAllCommentsInCM = false;
                            _this.isClearMetricEnabled = false;  
                        }
                    }, 2500);
                    }
                },
                specialClassNames: 'delete-comment discard-sp-width',
                duration: '',
                displayCloseIcon: true,
                background: true
            });
        },
        handleActionClick(action) {
            if (action === "comment") {
                this.metricCommentsFunc(this.currentCell.row, true);
            }
            if (action === "save") {
                let unsavedChanges = this.changes.unsavedChanges.filter(i => i.row === this.currentCell.row && i.column === this.currentCell.col)
                let unsavedComments = this.changes.unsavedComments.filter(i => i.metric_name === this.currentCell.metric_name && i.month === this.currentCell.col)
                this.updateDB({type:"save",body: { unsavedChanges, unsavedComments, deletedComments: [] }});
            }
            if (action === "post") {
                let savedItems = this.savedItems.list.filter(i => i.metric_name === this.currentCell.metric_name && i.month === this.currentCell.col);
                this.updateDB({type:"post",body: { savedItems, unsavedChanges: [], unsavedComments: [] }});
            }
            if (action === 'edit') {
                this.renderCellEditOverlay();
            }
            if (action === 'unpost') {
                this.showCellUnpost = true;
            }
        },
        getIndexdColor(index = 0) {
            const colorIndex = index % this.colorArray.length
            return this.colorArray[colorIndex];
        }
        },
    computed: {
        ...mapGetters(['currentProgram','currentData','currentFormatedData','currentYear','currentUserName','currentUserGroups','currentUserEmail','currentSavedValues','currentExtractedValues','currentUnpostedValues']),
        },
    data() {
        return {
            colorArray: ['#ff6347', '#419393', '#9b469b', '#18c38a', '#f8c169'],
            deleteCommentSelectionCount: 0,
            deleteAllCommentsInCM: false,
            selectedCommentsCount: 0,
            renderCommentsFor: "",
            commentShowMonth: "",
            allCommentsSelected: false,
            selectedCommentsArray: new Array(12).fill(0).map(() => new Array(0)),
            longMonths: ['january','february','march','april','may','june','july','august','september','october','november','december'],
            showCellUnpost: false,
            showEditedCellPost : false,
            actionBarConfig: {},
            actionBarTop: 0,
            actionBarLeft: 0,
            showActionBar: false,
            showClearMetricDropDown: false,
            selectInputPostModal: false,
            selectInputSaveModal: false,
            inputCellValue: '',
            newCellValue: '',
            cellEditComment: '',
            showCellEdit: false,
            monthsArray: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            trimmedMonthsArray: [],
            clearMetricFromSelection: '',
            clearMetricToSelection: '',
            clearMetricSelection: [],
            metricItems: [],
            expandMode: false,
            isClearMetricEnabled: false,
            showHelpMenu: false,
            root: 'test-hot',
            renderSelection: false,
            tableHeight: window.innerHeight - 155 + "px",
            tableWidth: window.innerWidth,
            currentCell: {
                row: "",
                col:"",
                value: "",
                metric_name:"",
                canComment: false
            },
            hotSettings: {
                rowHeights: 30,
                // colWidths: [((window.innerWidth/20)*3.45), ((window.innerWidth/20)*1.5), ((window.innerWidth/20)*2), ((window.innerWidth/20)), (window.innerWidth/20), (window.innerWidth/20), (window.innerWidth/20), (window.innerWidth/20), (window.innerWidth/20), (window.innerWidth/20), (window.innerWidth/20), (window.innerWidth/20), (window.innerWidth/20), (window.innerWidth/20), (window.innerWidth/20), (window.innerWidth/20)],
                data: [],
                additionalData: {},
                userGroups: this.userGroups,
                beforeChange: this.beforeChange,
                // viewportColumnRenderingOffset: 70,
                scrollH: 'hidden',
                afterSelectionByProp: this.afterCellSelection,
                licenseKey: LICENSE_KEY,
                //stretchH: 'all', //this is causing issue of comment icon to be in-visible on the first column
                //manualColumnResize: true, //this is causing issue of comment icon to be in-visible on the first column
                columnSorting: true,
                colHeaders: ['Metric Name','Target','Category','PPM',
                                       'Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec',
                                       'january_status','february_status','march_status','april_status','may_status','june_status','july_status','august_status','september_status','october_status','november_status','december_status',
                                       'january_target_acheived','february_target_acheived','march_target_acheived','april_target_acheived','may_target_acheived','june_target_acheived','july_target_acheived','august_target_acheived','september_target_acheived','october_target_acheived','november_target_acheived','december_target_acheived',
                                       ''],  
                columns: [
                    {
                        data: 'name',
                        readOnly: true,
                    },
                    {
                        data: 'target_array',
                        readOnly: true,
                    },
                    {
                        data: 'category',
                        readOnly: true,
                    },
                    {
                        data: 'in_ppm',
                        readOnly: true,
                    },
                    {
                        data: 'january',
                        type: 'text',
                    },
                    {
                        data: 'february',
                        type: 'text'
                    },
                    {
                        data: 'march',
                        type: 'text'
                    },
                    {
                        data: 'april',
                        type: 'text'
                    },
                    {
                        data: 'may',
                        type: 'text'
                    },
                    {
                        data: 'june',
                        type: 'text'
                    },
                    {
                        data: 'july',
                        type: 'text'
                    },
                    {
                        data: 'august',
                        type: 'text'
                    },
                    {
                        data: 'september',
                        type: 'text'
                    },
                    {
                        data: 'october',
                        type: 'text'
                    },
                    {
                        data: 'november',
                        type: 'text'
                    },
                    {
                        data: 'december',
                        type: 'text'
                    },
                    {
                        data: 'january_status',
                        readOnly: true,
                    },
                    {
                        data: 'february_status',
                        readOnly: true,
                    },
                    {
                        data: 'march_status',
                    readOnly: true,
                        },
                    {
                        data: 'april_status',
                        readOnly: true,
                    },
                    {
                        data: 'may_status',
                        readOnly: true,
                    },
                    {
                        data: 'june_status',
                        readOnly: true,
                    },
                    {
                        data: 'july_status',
                        readOnly: true,
                    },
                    {
                        data: 'august_status',
                        readOnly: true,
                    },
                    {
                        data: 'september_status',
                        readOnly: true,
                    },
                    {
                        data: 'october_status',
                        readOnly: true,
                    },
                    {
                        data: 'november_status',
                        readOnly: true,
                    },
                    {
                        data: 'december_status',
                        readOnly: true,
                    },
                    {
                        data: 'january_target_achieved',
                        readOnly: true,
                    },
                    {
                        data: 'february_target_achieved',
                        readOnly: true,
                    },
                    {
                        data: 'march_target_achieved',
                    readOnly: true,
                        },
                    {
                        data: 'april_target_achieved',
                        readOnly: true,
                    },
                    {
                        data: 'may_target_achieved',
                        readOnly: true,
                    },
                    {
                        data: 'june_target_achieved',
                        readOnly: true,
                    },
                    {
                        data: 'july_target_achieved',
                        readOnly: true,
                    },
                    {
                        data: 'august_target_achieved',
                        readOnly: true,
                    },
                    {
                        data: 'september_target_achieved',
                        readOnly: true,
                    },
                    {
                        data: 'october_target_achieved',
                        readOnly: true,
                    },
                    {
                        data: 'november_target_achieved',
                        readOnly: true,
                    },
                    {
                        data: 'december_target_achieved',
                        readOnly: true,
                    },
                    {
                        data: "metric_comments",
                        readOnly: true,
                    }
                ],
                fixedColumnsLeft: 2,
                dropdownMenu: ['filter_by_value', 'filter_action_bar'],
                filters: true,
                autoRowSize: false,
                // columnSorting: true,
                hiddenColumns: {
                    columns: [16,17,18,19,20,21,22,23,24,25,26,27,
                              28,29,30,31,32,33,34,35,36,37,38,39]
                            //   40,41,42,43,44,45,46,47,48,49,50,51]
                },
                hiddenRows: {
                    rows: []
                },
                afterOnCellMouseDown: function(e, coords, TD){
                    if(coords.col === 0){
                        this.rootElement.__vue__.$emit('onMetricCommentBtnClk',coords.row);
                    }
                    
                },
                cells: function(row,col,prop){
                    var access_level = "unknown"
                    // console.log(`cells: ${String(this.userGroups).toLowerCase()}`)
                        if((String(this.userGroups).toLowerCase().indexOf('readonly') > -1)){
                            access_level = "readonly"
                        }
                        if((String(this.userGroups).toLowerCase().indexOf('poweruser') > -1)){
                            access_level = "poweruser"
                        }
                        if((String(this.userGroups).toLowerCase().indexOf('admin') > -1)){
                            access_level = "admin"
                        }
                    var cellProperties = {}
                    cellProperties.access_level = access_level
                    // console.log(`computed access_level: ${access_level}`)
                    cellProperties.renderer = "custom-renderer"
                    return cellProperties
                },


            },
            changes: {
                unsavedChanges: [],
                unsavedComments:[],
                currentChanges: {
                    row: "",
                    column: "",
                    name: "",
                    beforeValue: "",
                    afterValue: "",
                    status: "",
                    comments: {
                        "comment":"",
                        "timeStamp":"",
                        "userEmail":""
                        },
                    },
                currentComments: {
                    comment: "",
                    userEmail: "",
                    timeStamp: ""
                    }
                },
            savedItems: {
                list:[],
                toBeSaved:{
                    unsavedChanges:[],
                    unsavedComments:[]
                    }
                },
            postedItems: {
                toBePosted: {
                    savedItems:[],
                    unsavedChanges: [],
                    unsavedComments:[]
                    }
                },
            metricCommentsForModal: [],
            commentsModalShow: false,
            saveModalShow: false,
            postModalShow: false,
            addCommentsModalShow: false,
            metricCommentsModalShow: false,
            postSelectAll: false
            }  
        },
    components: {
        HotTable,
        ProgramSelection
        },
    beforeDestroy() {
        /*
        if(this.changes.unsavedChanges[0] || this.changes.unsavedComments[0]) {
            let r = confirm('All the changes will be lost. Are you sure you want to leave without saving?');
            if (!r) {
                window.stop();
            }
        }
        */
    },
    created(){
        this.hotSettings.userGroups = this.currentUserGroups;
        this.hotSettings.additionalData = this.currentData
        this.hotSettings.data = this.currentFormatedData
        this.savedItems.list = this.currentSavedValues
        let metricItems = this.currentFormatedData.map(i => i.name);
        this.metricItems = [...metricItems];
        metricItems = undefined;
        window.that = this;
        },
    watch: {
        clearMetricFromSelection() {
            this.trimmedMonthsArray = [];
            const index = this.monthsArray.indexOf(this.clearMetricFromSelection);
            this.trimmedMonthsArray = this.monthsArray.slice(index, 12);
        },
        commentShowMonth() {
            this.selectedCommentsArray = new Array(12).fill(0).map(() => new Array(0));
            this.allCommentsSelected = false;
        },
        currentData(){
            this.clearMetricFromSelection = '';
            this.clearMetricToSelection = '';
            this.clearMetricSelection = [];
            this.deleteAllCommentsInCM = false;
            this.$refs.hotTableComponent.hotInstance.getPlugin("Filters").clearConditions();
            this.$refs.hotTableComponent.hotInstance.getPlugin('Filters').filter();
            this.hotSettings.additionalData = this.currentData
            this.hotSettings.data = this.currentFormatedData
            console.log(this.currentFormatedData)
            let metricItems = this.$refs.hotTableComponent.hotInstance.getData().map(i => i[0]);
            this.metricItems = [...metricItems];
            metricItems = undefined;
            this.hotSettings.userGroups = String(this.currentUserGroups)
            this.savedItems =  {
                list:[],
                toBeSaved:{
                    unsavedChanges:[],
                    unsavedComments:[]
                   }
                }
            this.savedItems.list = this.currentSavedValues
            this.changes.unsavedChanges = []
            this.changes.unsavedComments = []
            this.clearDeleteComments();
            this.postedItems = {
                toBePosted: {
                    savedItems:[],
                    unsavedChanges: [],
                    unsavedComments: []
                    }
                },
            this.currentCell = {
                row: "",
                col:"",
                value: "",
                metric_name:"",
                canComment: false
                }
            this.$refs.hotTableComponent.hotInstance.render();            
            }
        }
    }

</script>
<style src="../../node_modules/handsontable/dist/handsontable.full.css"></style>
<style>
    .htCore td { white-space:nowrap }
    .red-tick-td {
        position: relative;
        border-left: 20px solid transparent;
        border-right: 0px solid transparent;
        border-top: 10px solid #C12F24;
        top: -22px;
        right: -263px;
        width: 0;
        height: 0;
        z-index: 999;
    }
    .red-tick-td-months {
        position: relative;
        border-left: 20px solid transparent;
        border-right: 0px solid transparent;
        border-top: 10px solid #C12F24;
        top: -21px;
        width: 0;
        height: 0;
        z-index: 999;
        visibility: hidden;
    }
    .red-tick-td-months-0 {
        position: relative;
        border-left: 20px solid transparent;
        border-right: 0px solid transparent;
        border-top: 10px solid #C12F24;
        top: 0px;
        width: 0;
        height: 0;
        z-index: 999;
        visibility: hidden;
    }
    .modal-dialog {
        margin-right: 0 !important;
        height: 81vh !important;
        width: 450px !important;
        top: 95px !important;
    }
    #hot-preview-2 {
     resize: both;
     overflow: auto;
     display: block;
    }
   #test-hot {
    /* height: 475px; */
    /* width: 900px; */
    /* overflow: hidden; */
    /* display: table-row */
    border: solid 1px;
    } 
    .modal-item {
        padding-bottom: 3%;
    }

    input[type=checkbox] {
        vertical-align: middle;
        float: right;
        }
    .comment-button {
        background-color: burlywood;
    }
    .handsontable.as-you-type-demo tr:first-child th {
  vertical-align: bottom;
}

.handsontable.as-you-type-demo th > div.filterHeader {
  border-top: 1px solid #CCC;
}

.handsontable.as-you-type-demo th > div.filterHeader > input {
  width: calc(100% - 10px);
  box-shadow: none;
  border: 1px solid #CCC;
  margin-top: 1px;
}

#externalFilter {
  display: none;
  margin-left: 10px;
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  margin-bottom: 50px;
}

#externalFilter > .button-holder {
  position: relative;
}

#externalFilter > .button-holder .buttons {
  left: 5px;
}

#externalFilter > .demo-columnChoose,
#externalFilter > .demo-columnChoose > select,
#externalFilter > .demo-filterSelect {
  width: 200px;
}

#externalFilter > .demo-columnChoose > select {
  display: block;
  margin: 2px 0px 10px 0px;
}

#externalFilter > .demo-filterSelect {
  border: 1px solid #cccccc;
  max-height: 200px;
  overflow: auto;
}

#externalFilter > .demo-filterSelect > .demo-controllers {
  font-weight: bold;
  border-bottom: 1px solid #cccccc;
  background-color: rgb(243, 243, 243);
  padding: 2px 0px;
}

#externalFilter > .demo-filterSelect > .demo-controllers {
  padding: 5px;
}

#externalFilter > .demo-filterSelect > .demo-items {
  padding: 5px;
}

#externalFilter > .demo-filterSelect > .demo-items > .demo-item > label:before {
  content: ' ';
  white-space: pre;
}

#externalFilter > .button-holder {
  margin-top: 10px;
}

/* basic positioning */
.legend { list-style: none; }
.legend li { float: left; margin-right: 10px; }
.legend span { border: 1px solid #ccc; float: left; width: 12px; height: 12px; margin: 2px; }
/* your colors */
.legend .empty { background-color: white; }
.legend .saved { background-color: #9df2aa; }
.legend .posted { background-color: #d7d8d6; }
.legend .unposted { background-color: #eddb55; }
.legend .miss { background-color: #f00; }

#someclass {
  overflow: auto;
  height: 100%;
}

.unsaved-comments {
    color: #999999;
}

</style>
<style scoped>

.multi-select-item:hover {
    cursor: pointer;
    background-color: #e6e6e6;
}
/* The Modal (background) */
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 99999; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 30%;
}

.unpost-modal-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 40%;
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.clear-metric-modal{
    box-shadow: 0px 0px 10px 1px #aaaaaa;
    position: absolute;
    background-color: #ffffff;
    z-index: 99999;
    height: 81vh;
    top: 60px;
    right: 0;
    width: 450px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: auto;
}
.edit-link {
    color: rgb(43, 119, 155);
    cursor: pointer;
    padding: 3px 10px;
    font-size: 15px;
    font-weight: bold;
    margin-left: 20px;
}
.red-banner {
    border-left: 20px solid transparent;
    border-right: 0px solid transparent;
    border-top: 6px solid rgb(255, 0, 0);
    width: 0px;
    height: 0px;
    /* position: absolute; */
    position: relative;
    right: -24px;
    top: -3px;
}
.btn-action-arp {
    color: #000 !important;
    font-weight: bold !important;
    height: 34px;
    position: relative;
    padding: 3px 10px;
    width: 90px;
}
.help-item {
    display: flex;
    justify-content: start;
    align-items: center;
    max-height: 70px;
    min-height: 55px;
}
.back-link {
    color: rgb(43, 119, 155);
    cursor: pointer;
    padding: 3px 10px;
    font-size: 17px;
    font-weight: bold;
    margin-left: 20px;
}
.btn-warning-arp {
    color: #000 !important;
    background-color: #FBC743 !important;
    font-weight: bold !important;

}
.help-item-head {
    width: 60px;
    border: 1px solid;
    padding: 3px 6px;
    margin-right: 10px;
}
.help-item-body {
    display: flex;
    flex-direction: column;
    line-height: 18px;
}
.metric-data-table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
}
.modalMetric {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 9999; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content-metric {
  background-color: #fefefe;
  margin-left: 250px;
  padding: 20px;
  border: 1px solid #888;
  width: 350px;
}

/* The Close Button */
.close-metric {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close-metric:hover,
.close-metric:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.dialogTextArea {
    width: 100%;
    padding: 6px 10px;
}

.clear-metric-sub-heading {
    font-size: 80%;
    line-height: 14px;
    width: 90%;
    margin-top: 8px;
}

.clear-metric-single-selected {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.clear-metric-close {
    width: 28px;
    height: 28px;
    margin-top: -8px;
}

.modal-month-chip {
    background-color: tomato;
    font-weight: bold;
    color: #ffffff;
    padding: 2px 8px;
    border-radius: 15px;
}

.modal-value-min-height {
    min-height: 19px;
}

.modal-separator-vertical {
    height: 36px;
    width: 1px;
    background-color: #F1F0EC;
}

.modal-inner-block {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    border: 2px solid #ececec;
    width: 93%;
    padding:4px 0;
    background: #FCFBFB;
}

.inline-separator {
    display: inline-block;
    height: 22px;
    width: 2px;
    background-color: #c8ced1;
    margin: 0px 2px;
    margin-bottom: -4px;
}

.action-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding-left: 16px;
    border-left: 1px solid #ccc;
}

.action-container .separator-vertical {
    height: 100%;
    width: 1px;
    background: #ccc;
    margin: 0px 12px 0px 8px;
}

</style>
